import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { Checkpoints, CheckpointTypeArrayValues } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
  name: z.string().min(1),
  description: z.string().optional(),
  checkpointType: z.enum(CheckpointTypeArrayValues).optional(),
  // Optional GitHub auto-push info
  githubRepo: z.string().optional(),
  githubBranch: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  checkpoint: Selectable<Checkpoints>;
  githubCommit?: {
    success: boolean;
    commitSha?: string;
    commitUrl?: string;
    error?: string;
  };
};

export const createCheckpoint = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/checkpoints/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
